module.exports = __webpack_public_path__ + "static/media/30.15e052ee.jpg";